export default {
    methods: {
        getMeta(key) {
            return this.$route.matched.map(m => m.meta[key]).filter(s => s)[0]
        }
    }
}
